import { Component, ReactNode } from "react";
import React from "react";
import WebDesigner, { EditorMode } from "./WebDesigner";
import { EditorState } from "./EditorTypes";
import CreateNewGUID from "vagaro-website-rendering/src/components/Utilities/CreateNewGUID";
import DropTarget from "./DropTarget";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { GetWBComponentByTypename } from "./Data/WBData";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import '../../Styles/wb.canvas.ui.css';
import { SiteData } from "./Data/SiteData";
import WBComponentWrapper from "./WBComponentWrapper";
import RenderSiteStyle from "./RenderSiteStyle";
import { CreateNewPage } from "./Utilities/PageDataHandler";
import { AlertConfirm } from "./ConfirmationPopups";
import  { GetLinearPageOptions } from "./Menus/PageSelectMenu";
import { editTextPlaceHolder } from "./Data/WBComponentDefaults";
import HoverToolTip from "./HoverToolTip";
import RenderCustomCSS from "./RenderCustomCSS";
import AnnouncementBanner from "./WBComponents/AnnoucementBanner";
import { OpenBlogSettingsFromEditor } from "./Menus/BlogSettingsPopup";







type CanvasProps = {
    wbManager:WebDesigner
    layout:LayoutNode;
    editorState:EditorState;
    children:ReactNode;
    previewState:ScreenSize
    canvasRef:React.RefObject<HTMLDivElement>;
    siteData:SiteData;
    onScrollFunc:Function;
    isDragging:boolean;
    onUpdateDropTargets:Function;
 
}




export function CreateBlankLayoutNode(typename:string="Section",id:string|null =null):LayoutNode{


  let layoutNode  = new LayoutNode();
  layoutNode.typename = typename;
  layoutNode.parent = null;
  layoutNode.children = [];
  layoutNode.id = id??CreateNewGUID();
  layoutNode.content = editTextPlaceHolder;

  return layoutNode;


}



export function assignParentsToLayoutRecursive(obj:LayoutNode,applyUniqueIds:boolean = false){
  if(applyUniqueIds){

    
    obj.id = CreateNewGUID();
  }
  
  if(obj.children){
    for(let i = 0;i<obj.children.length;i++){

      let child = obj.children[i];
      child['parent'] = obj;
      child['childIndex'] = i;

      obj.children[i].parent = obj;
      obj.children[i].childIndex = i;
      
      assignParentsToLayoutRecursive(obj.children[i],applyUniqueIds);
    }

  }
}

export default class WBCanvas extends Component <CanvasProps,{update:boolean}>{


    canvasRef = React.createRef<HTMLDivElement>();
    resizeObserver:ResizeObserver|null = null;
    optimizeRendering = false;
    scrollTop = 0;

    constructor(props:CanvasProps){
        super(props);
        (window as any).canvasRef = this;
        // this.RenderComponentRecursive = this.RenderComponentRecursive.bind(this);
        this.RenderLayoutWIthSeperateFooter = this.RenderLayoutWIthSeperateFooter.bind(this);
        this.updateScroll = this.updateScroll.bind(this);
        this.resizeObserver = null;
        this.canvasRef = props.canvasRef;
        this.state = {update:false}
        this.optimizeRendering =  props.siteData.editorSettings.opimizeRendering; 

        if(this.optimizeRendering){
          (window as any).optimizevrendering = true;
        }
    }

    
    reEvaluateDropTargets(){


      this.props.onUpdateDropTargets();

    }




    componentDidUpdate(prevProps: Readonly<CanvasProps>, prevState: Readonly<{ update: boolean; }>, snapshot?: any): void {
      if(!prevProps.isDragging && this.props.isDragging){
        this.reEvaluateDropTargets();
      }
      else if(prevState.update!=this.state.update){
        this.reEvaluateDropTargets();
      }
    }


    componentDidMount(): void {
      
      if(this.resizeObserver==null){
        this.resizeObserver = new ResizeObserver ((entries) => {
          for (let entry of entries) {
    
            if(entry.target==this.canvasRef.current){
              
          

              let newWidth = entry.contentRect.width;
              if(newWidth<=750){
                document.body.classList.add("mobile-break");
                
              }
              else{
                document.body.classList.remove("mobile-break");
              }
              
            }
    
          }
        });
      }

      if(this.canvasRef.current&&this.resizeObserver)
        this.resizeObserver.observe(this.canvasRef.current);

      if(this.props.isDragging){
        this.reEvaluateDropTargets();
      }
 
    }


  componentWillUnmount(): void {
    if(this.resizeObserver)
    this.resizeObserver.disconnect();
  }


  updateScroll(e:any){

  /*
  Only update every 150 pixels instead of every scroll, this is needed to render new drop targets as sections come into view
  */

    if(this.canvasRef.current && this.props.isDragging){
      let top = e.target.scrollTop;
      if(Math.abs(top-this.scrollTop)>150){
    
        this.scrollTop = top;
        this.setState({update:!this.state.update})
      }

    }

  }


    render(): ReactNode {

      const NoPageSelected = ()=>{
     return    <div
        className="w-full h-full center-all"
        style={{ color: "#333" }}
      >
        {" "}
        <div
          className="flex-column gap-med align-center"
          style={{ textAlign: "center", padding: "12px" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="3em"
            viewBox="0 0 384 512"
            fill="#333"
          >
            <path d="M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM192 176c-13.3 0-24 10.7-24 24V312c0 13.3 10.7 24 24 24s24-10.7 24-24V200c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" />
          </svg>
          <span style={{ fontWeight: "600", fontSize: "24px" }}>
            No Page Selected
          </span>
          <span>
            Add a new page or select an existing page to start editing
          </span>
          <button
            style={{ marginTop: "12px" }}
            className="empty-add-button"
            onClick={() => {
              this.props.wbManager.toggleLoading(true);
              const newID = "";
              let name = "New Page";
              let pageList = GetLinearPageOptions(
                this.props.siteData
              );
              let max = 1;
              for (let i = 0; i < pageList.length; i++) {
                let item = pageList[i];
                if (item.label.includes(name)) {
                  let parse = item.label.replace(name, "");
                  let num = parseInt(parse);
                  if (!isNaN(num) && num >= max) max = num + 1;
                }
              }

              name += " " + max;

              CreateNewPage(
                newID,
                this.props.wbManager.props.siteData,
                name,
                (data: any) => {
                  this.props.siteData.pages.push({
                    name: name,
                    url: name.replaceAll(" ", "-").toLowerCase(),
                    pageId: data.data.data.pageId,
                    children: [],
                    isDisabled: false,
                    content: "",
                    nested: false,
                    titleTag: "",
                    folderId: "",
                    openGraphImageUrl: "",
                    metaDescription: "",
                    isFolder: false,
                    order: 0,
                    isLandingPage: false,
                    isHidePage: false,
                    isDuplicateAllLocationPage:false
                  });
                  this.props.wbManager.toggleLoading(false);
                  this.props.wbManager.setState({pageSelectKey:this.props.wbManager.state.pageSelectKey+1})
                  this.props.wbManager.setState({pageMenuLoadToggle:!this.props.wbManager.state.pageMenuLoadToggle});
                  this.props.wbManager.tryLoadPage(data.data.data.pageId);
                },
                (data: any) => {
                  this.props.wbManager.toggleLoading(false);
                  AlertConfirm(
                    "Oops! Couldn't create a new page, please try again"
                  );
                }
              );
            }}
          >
            Add New Page
          </button>
      
        </div>
      </div>
      }
      
   
      let style:{} = {width:"100%"};
      let mobileBreakClass = "";
      if(this.props.previewState==ScreenSize.Tablet){

        style = {
          width:"780px",
          height:"1200px"
   
        }

        mobileBreakClass = "tablet-break screen-tablet";

      }
      else if(this.props.previewState==ScreenSize.Mobile){

        style = {
          width:"375px",
          height:"720px"
 
        }

        mobileBreakClass = "mobile-break tablet-break screen-mobile";
      }

      else{
        mobileBreakClass = "screen-desktop"
      }

      const layoutMode = this.props.wbManager.state.layoutMode?" layout-mode":"";
    


        return (
          <div
            id="v-canvas"
            className={
              "canvas nice-scroll v-site " +
              mobileBreakClass +
              layoutMode +
              " " +
              (this.props.wbManager.props.siteData.editorSettings
                .disableAnimations
                ? "no-transitions"
                : "")
            }
            ref={this.canvasRef}
            onScroll={(e: any) => {
              this.props.onScrollFunc();
              this.updateScroll(e);
            }}
            style={style}
          >
            {this.props.layout.children.length < 2 &&
              !this.props.wbManager.state.isLoading && <NoPageSelected/>}

            {this.props.layout.children.length > 1 && (
              <>
                <RenderSiteStyle siteData={this.props.siteData} />
                <RenderCustomCSS key={"custom-css"+this.props.wbManager.state.currentPageId} siteData={this.props.siteData} root={this.props.layout} />
                {/* {this.renderComponentRecursive(this.props.layout,null,this.props.previewState)} */}
             
                <this.RenderLayoutWIthSeperateFooter dropList={this.props.wbManager.draggedDropList} />
                {this.props.children}
              </>
            )}
          </div>
        );
    }


    //manually render the header and content seperate from the footer inside a main container to ensure the footer stays at the bottom and that the page height is at least the full window height
    RenderLayoutWIthSeperateFooter({dropList}:{dropList:string[]} ){

      const root = this.props.layout;


      const pageRootComp = GetWBComponentByTypename(wBComponentTypeNames.pageRoot);
      const RenderRoot = pageRootComp.RenderLayout;
      const footer = root.children.find((child)=>child.typename===wBComponentTypeNames.footer);
  

      return <>
       
      <RenderRoot screenSize={this.props.previewState} component={root} isEditor={true} userContext={this.props.siteData.userContext}>
      
      <AnnouncementBanner 
      isEditor={true}
      pageData={this.props.siteData.pages}
      inId="ann"
      atts={this.props.siteData.siteStyling.announcementBar}
      onSelect={()=>{
        this.props.wbManager.openSettingsMenu();
        setTimeout(()=>{
        this.props.wbManager.openToAnnouncementBar()},10);
      }}
      
      />
        <div className="v-site-main-content-container" style={(root.children.length==2 && !this.props.isDragging)?{justifyContent:"flex-start",gap:"40vh"}:{}}>
        {root.children.map((child,i)=>{

          

          if(child.typename != wBComponentTypeNames.footer){
            return <RenderComponentRecursive  dropList={dropList} isDragging={this.props.isDragging} optimizeRendering={this.optimizeRendering} designer={this.props.wbManager} key={child.id} parent={root} obj={child} screenSize={this.props.previewState} inView={true} depth={1} blogMode={this.props.wbManager.state.mode==EditorMode.Blogging}/>
          }
          else
            return null;
          //return this.RenderComponentRecursive(this.props.wbManager, child,root,this.props.previewState,true,2,this.props.wbManager.state.mode==EditorMode.Blogging);
        })}
  {dropList.includes(root.typename)&&
    <DropTarget key={root.id + "after"}  id={root.id + "top"+ root.typename}  componentType={root.typename} componentDef={ GetWBComponentByTypename(root.typename)}/>
    }
    
        </div>


        {footer&&<>

          {this.props.wbManager.state.mode!=EditorMode.Blogging&&  <RenderComponentRecursive dropList={dropList} isDragging={this.props.isDragging} optimizeRendering={this.optimizeRendering} designer={this.props.wbManager} key={footer.id} parent={root} obj={footer} screenSize={this.props.previewState} inView={true} depth={1} blogMode={false}/>
          }
          {/* // this.RenderComponentRecursive(this.props.wbManager,footer,root,this.props.previewState,true,2)} */}
          {this.props.wbManager.state.mode==EditorMode.Blogging&& <div className="w-full center-all gap-med v-section v-footer block-edit locked-bg"   ><LockIcon/> Footer locked when blogging</div>}
          </>
        }
        </RenderRoot>
        </>


    }

    RenderSection(section:LayoutNode,screenSize:ScreenSize){
      const sec = GetWBComponentByTypename(wBComponentTypeNames.section);

      return <sec.RenderLayout screenSize={screenSize} component={section} isEditor={true} userContext={this.props.siteData.userContext}>
        {(section.inView||!this.optimizeRendering)&&  section.children.map((child,i)=>{
          return  <RenderComponentRecursive dropList={this.props.wbManager.draggedDropList} isDragging={this.props.isDragging} optimizeRendering={this.optimizeRendering} designer={this.props.wbManager} key={child.id} parent={section} obj={child} screenSize={screenSize} inView={true} depth={2} blogMode={this.props.wbManager.state.mode==EditorMode.Blogging}/>
          //this.RenderComponentRecursive(this.props.wbManager,child,section,screenSize,true,2);
        })}
      </sec.RenderLayout>
      
    }
}

function LockIcon(){
 return  <svg xmlns="http://www.w3.org/2000/svg" height={"1em"} fill="currentColor" viewBox="0 0 448 512"><path d="M144 144l0 48 160 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192l0-48C80 64.5 144.5 0 224 0s144 64.5 144 144l0 48 16 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l16 0z"/></svg>
}

function    RenderComponentRecursive({isDragging,dropList,optimizeRendering,designer,obj,parent,screenSize,inView,depth,blogMode}:{isDragging:boolean,dropList:string[],optimizeRendering?:boolean,designer:WebDesigner,obj:LayoutNode,parent?:LayoutNode,screenSize:ScreenSize,inView:boolean,depth:number,blogMode?:boolean}):any{
     
  if(depth>250){
    console.error("Exceded Layout Depth");
    return null;
  }

  if(blogMode&&obj.typename === wBComponentTypeNames.navigationBar){

    return <div className="w-full center-all flex-column gap-large locked-bg" style={{padding:"16px"}} >
     <div className="flex-row gap-med"> <LockIcon/> Navigation locked when blogging</div>
        <button className="publish-button"
        id='manage-post-settings-button'
        onClick={()=>{
          OpenBlogSettingsFromEditor(designer);
        }}
        
        >Manage Post Settings</button>
    </div>

  }


    let wbDef = GetWBComponentByTypename(obj.typename);

    let Component = wbDef.RenderLayout;

    if(!Component)
        return null;

  // const isDragging = this.props.isDragging;
  // const dropList = (this.props.wbManager.draggedDropList??[]);

    
  if(inView && !obj.inView)
    inView = false;
  
    return (
      <React.Fragment key={obj.id +"fragment"}>
        { 
          inView &&
          parent!=null&&isDragging&& dropList.includes(parent.typename) && obj.typename!=wBComponentTypeNames.navigationBar&&obj.typename!=wBComponentTypeNames.footer&& //reneable this to diable droping at the end of page root to reserver space for footer
        <DropTarget  key={obj.id + "after"}  id={obj.id + "top"+ obj.typename}  componentType={parent.typename} componentDef={ GetWBComponentByTypename(parent.typename)}/>//store wbcomponent attribute for calc closesest drop target
        
        }
        <WBComponentWrapper screenSize ={screenSize} component={obj} key={obj.id} isEditor={true} userContext={designer.props.siteData.userContext}  >
    
          {(obj.inView||!optimizeRendering)&& //Render All Nested Child Components
       
            
            obj.children.map((child, i) => {
       

              return <RenderComponentRecursive dropList={dropList} isDragging={isDragging} optimizeRendering={optimizeRendering} designer={designer} key={child.id} parent={obj} obj={child} screenSize={screenSize} inView={inView} depth={depth+1} blogMode={blogMode}/> 
              
              // this.RenderComponentRecursive(this.props.wbManager, child,obj,screenSize,inView,depth+1,this.props.wbManager.state.mode==EditorMode.Blogging);
            })
            }



          {isDragging&& inView&& dropList.includes(obj.typename)&&  (obj.typename!=wBComponentTypeNames.pageRoot)&& //reneable this to diable droping at the end of page root to reserver space for footer
              <DropTarget key={obj.id + "center"} id={obj.id + "center"} componentType={obj.typename} componentDef={wbDef}/>
           }

          {
            obj.typename===wBComponentTypeNames.section && obj.children.length <=0 && designer.state.editSate == EditorState.Normal &&
            <div className="center-all w-full h-full">

            <button className="open-template-menu-button add-styling-button" style={{borderRadius:"4px",border:"1px solid #888888",margin:"12px",padding:"8px 16px",color:"var(--input-selected-primary)"} as {}} 
            
            onClick={
              ()=>{
                designer.templateNode = obj;
              
              designer.switchToEditorState(EditorState.TemplateMenu);
              
              }

            }>+ Select Template    </button></div>
          }
    
        </WBComponentWrapper>
          
           {designer.props.siteData.editorSettings.showAddSectionButtons&&
           designer.state.mode!=EditorMode.Blogging&&
           designer.state.editSate === EditorState.Normal &&  (obj.typename===wBComponentTypeNames.section||obj.typename===wBComponentTypeNames.navigationBar)&&

              <button className="add-section-button block-edit"
           
              onClick={ ()=>

                designer.addNewSectionNexToOther(obj)

              }

              >+ Add Section
              
              <HoverToolTip text="Add Section" />
              </button>
          } 
          
      </React.Fragment>
    );
  }